import { render, staticRenderFns } from "./payments-page.vue?vue&type=template&id=18654324"
import script from "./payments-page.vue?vue&type=script&lang=js"
export * from "./payments-page.vue?vue&type=script&lang=js"
import style0 from "./payments-page.vue?vue&type=style&index=0&id=18654324&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports